<template>
  <v-container>
    <v-row class="text-center align-center" style="min-height: 100px">
      <v-col cols="6">
        <v-row class="align-center">
          <v-col cols="2" class="d-flex flex-column align-left">
            <v-img alt="MK Plus Mobile App Development & Test Automation" class="shrink" contain
              :src="require('@/assets/logo.png')" transition="scale-transition" width="75" />
          </v-col>
          <v-col cols="10">
            <v-row class="justify-center">
              <div class="mt-5 text-h6">MK PLUS &#8226; MAKSYM K. &#8226;
                <a style="text-decoration: none; color: #7C4DFF;" href="https://www.linkedin.com/in/maxkrut/"
                  target="_blank">LINKEDIN
                </a>
              </div>
            </v-row>
            <v-row class="justify-center">
              <div class="text-overline">
                &#109;&#107;&#64;&#109;&#107;&#46;&#112;&#108;&#117;&#115; &#8226; 1-250-3208951 &#8226; Ottawa, Canada
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="d-flex justify-end">
        <v-row>
          <v-col cols="9">
            <v-row class="justify-center">
              <div class="mt-5 text-h6">AI-DRIVEN QUALITY & DEVELOPMENT</div>
            </v-row>
            <v-row class="justify-center">
              <div class="text-overline">AI ADAPTATION &#8226; QUALITY AUDIT &#8226; DATA &#8226; MOBILE APPS</div>
            </v-row>
          </v-col>
          <v-col cols="3" class="d-flex flex-column">
            <v-btn class="mt-3" variant="outlined" @click.stop="contactModalShown = true">Contact</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10" style="text-decoration: none; color: #7C4DFF;" >
          <h3>AI Adaptation</h3>
        </span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 450px"></v-divider>
        <article>
          <h3 hidden>AI Adaptation</h3>
          <p>
            <span class="text-h6 font-weight-light">
              Businesses that integrate AI today gain a compounding advantage — faster operations,
              smarter decisions, and leaner teams. Those that wait don't just fall behind; they become
              costly operations competing against automated rivals. From workflow automation to intelligent
              customer engagement, we help small and mid-size businesses adopt AI
              strategically — not as a trend, but as a <b style="text-decoration: none; color: red;">market weapon</b>.
            </span>
          </p>
        </article>
      </v-col>
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <v-img alt="AI Adaptation for Business" class="shrink mr-2" contain
          :src="require('@/assets/ai.png')" transition="scale-transition" width="460" />
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <a style="text-decoration: none; color: #7C4DFF;" href="https://github.com/MaksymKrut/appium2-greenfield"
          target="_blank">
          <v-img alt="Quality Auditor Maksym Krutskykh" class="shrink mr-2" contain :src="require('@/assets/audit.png')"
            transition="scale-transition" width="260" />
        </a>
      </v-col>
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10">
          <a style="text-decoration: none; color: #7C4DFF;" href="https://github.com/MaksymKrut/appium2-greenfield"
            target="_blank">
            <h3>Quality Audit</h3>
          </a></span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 420px"></v-divider>
        <article>
          <h3 hidden>Quality Audit</h3>
          <p>
            <span class="text-h6 font-weight-light">
              User Experience and Quality Audit are critical pillars of any software or hardware development
              lifecycle. An independent, expert assessment cuts through the natural
              <b style="text-decoration: none; color: red;">conflict of interest</b>
              between vendors and clients — ensuring that speed of delivery
              never comes at the expense of reliability, performance, or user trust.
            </span>
          </p>
        </article>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10">
          <a style="text-decoration: none; color: #7C4DFF;" href="https://www.linkedin.com/in/maxkrut/" target="_blank">
            <h3>Data Quality</h3>
          </a></span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 450px"></v-divider>
        <article>
          <h3 hidden>Data Quality</h3>
          <p>
            <span class="text-h6 font-weight-light">
              Data Warehouse ETL Testing and Data Quality Management ensure accuracy, consistency,
              and reliability across your data pipeline. We automate validation with Python and
              industry-standard frameworks — catching issues before they reach dashboards,
              reports, or business decisions.
            </span>
          </p>
        </article>
      </v-col>
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <a style="text-decoration: none; color: #7C4DFF;" href="https://www.linkedin.com/in/maxkrut/" target="_blank">
          <v-img alt="Data Quality Auditor Maksym Krutskykh" class="shrink mr-2" contain
            :src="require('@/assets/data.png')" transition="scale-transition" width="260" />
        </a>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <a style="text-decoration: none; color: #7C4DFF;" href="https://github.com/MaksymKrut/appium2-greenfield"
          target="_blank">
          <v-img alt="Appium Project Maksym Krutskykh GitHub" class="shrink mr-2" contain
            :src="require('@/assets/appium.png')" transition="scale-transition" width="260" />
        </a>
      </v-col>
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10">
          <a style="text-decoration: none; color: #7C4DFF;" href="https://github.com/MaksymKrut/appium2-greenfield"
            target="_blank">
            <h3>Mobile App Test Automation</h3>
          </a></span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 420px"></v-divider>
        <article>
          <h3 hidden>Mobile App Test Automation</h3>
          <p>
            <span class="text-h6 font-weight-light">
              With modern tools like Appium, test automation covers both iOS and Android
              from a single framework. Written once, tests run 24/7 — catching
              million-dollar code defects before your users do.
            </span>
          </p>
        </article>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10">
          <a style="text-decoration: none; color: #7C4DFF;" href="https://apkpure.com/developer/Maksym%20Krutskykh"
            target="_blank">
            <h3>Android App Development</h3>
          </a></span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 450px"></v-divider>
        <article>
          <h3 hidden>Android App Development</h3>
          <p>
            <span class="text-h6 font-weight-light">
              Reach billions of devices with a native or hybrid Android presence.
              Development can share a codebase with iOS via Flutter for faster delivery,
              or go platform-native for maximum performance and control.
            </span>
          </p>
        </article>
      </v-col>
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <a style="text-decoration: none; color: #7C4DFF;" href="https://apkpure.com/developer/Maksym%20Krutskykh"
          target="_blank">
          <v-img alt="Play Store Android App Development Maksym Krutskykh" class="shrink mr-2" contain
            :src="require('@/assets/play_store.png')" transition="scale-transition" width="260" />
        </a>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col class="bg-deep-purple-accent-2 d-flex flex-column align-center justify-center" sm="12" md="6">
        <a style="text-decoration: none; color: #7C4DFF;"
          href="https://apps.apple.com/us/developer/maksym-krutskykh/id1618027639" target="_blank">
          <v-img alt="App Store App Development Maksym Krutskykh" class="shrink mr-2" contain
            :src="require('@/assets/app_store.png')" transition="scale-transition" width="260" />
        </a>
      </v-col>
      <v-col sm="12" md="6" class="d-flex flex-column align-center justify-center">
        <span class="text-h2 font-weight-light my-10">
          <a style="text-decoration: none; color: #7C4DFF;"
            href="https://apps.apple.com/us/developer/maksym-krutskykh/id1618027639" target="_blank">
            <h3>iPhone App Development</h3>
          </a></span>
        <v-divider color="#7C4DFF" class="mb-5" style="max-width: 420px"></v-divider>
        <article>
          <h3 hidden>iPhone App Development</h3>
          <p>
            <span class="text-h6 font-weight-light">
              Apps for iPhone, iPad, and macOS — from lightweight utilities to full-scale
              platforms with maps, messaging, camera integration, and more. Target the
              premium user base across the US and Canada.
            </span>
          </p>
        </article>
      </v-col>
    </v-row>



    <v-row class="text-center" style="height: 24px">
    </v-row>

    <Contact v-model:contactModalShown="contactModalShown" />
    <Invest v-model:investModalShown="investModalShown" />
  </v-container>
</template>

<script>
import Contact from '@/modals/Contact.vue';
import Invest from '@/modals/Invest.vue';

export default {
  name: 'Home',
  components: {
    Contact,
    Invest,
  },
  data() {
    return {
      contactModalShown: false,
      investModalShown: false,
    };
  },
};
</script>

<style scoped>
h3 {
  font-weight: 300;
}

article {
  max-width: 600px;
}
</style>
